"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalComponent = exports.Modal = void 0;
const qcobjects_1 = require("qcobjects");
class SignalComponent extends qcobjects_1.Component {
    constructor() {
        super(...arguments);
        this._signals = {};
    }
    on(signalName, callback) {
        this._signals[signalName] = callback;
    }
    fireSignal(signalName) {
        this._signals[signalName].call(this);
    }
}
exports.SignalComponent = SignalComponent;
class Modal extends SignalComponent {
    constructor(component) {
        super(component);
        this.name = "modal";
        this.shadowed = true;
        this.tplsource = "inline";
        this.template = `
    <style>
    .modal_background_${this.__instanceID} {
        top:0;
        left:0;
        right:0;
        bottom:0;
        position:fixed;
        margin:0;
        padding:0;
        background-color:rgba(1,1,1,0.94);
        z-index:9999999;
        opacity:0;
        transition: 1s;
    }
    .modal.modal_${this.__instanceID}{
        margin: 0 auto;
        position: relative;
        max-width: 50% !important;
        max-height: 50% !important;
        min-width: 30% !important;
        min-height: 30% !important;
        text-align: center;
        margin-top: 27vh;
        opacity: 0;
        transition: 1s;
    }
    .open {
        opacity: 1 !important;
    }
    </style>
    <div class="modal_background_${this.__instanceID}">
    <div class="modal modal_${this.__instanceID}">
    </div>
    </div>
    `;
        this.enclosureComponentClass = component.enclosureComponentClass;
        this.body.classList.add(`modal_container_${this.__instanceID}`);
        this.body.style.display = "contents";
        this.submodal = (0, qcobjects_1.New)((0, qcobjects_1.ClassFactory)(component.enclosureComponentClass), {
            __parent__: this,
            shadowed: this.shadowed,
            data: this.data
        });
    }
    open() {
        this.body.style.display = "contents";
        setTimeout(() => {
            this.shadowRoot?.subelements(`.modal_background_${this.__instanceID},.modal.modal_${this.__instanceID}`)
                .map((element) => {
                return element.classList.add("open");
            });
        }, 100);
    }
    close(remove = false) {
        this.shadowRoot?.subelements(`.modal_background_${this.__instanceID},.modal.modal_${this.__instanceID}`)
            .map((element) => {
            return element.classList.remove("open");
        });
        setTimeout(() => {
            this.body.style.display = "none";
        }, 1000);
        if (remove) {
            setTimeout(() => {
                this.remove();
            }, 1000);
        }
    }
    remove() {
        this.body.remove();
    }
    done(standardResponse) {
        const submodalRoot = this.shadowRoot.subelements(`.modal.modal_${this.__instanceID}`).pop();
        submodalRoot?.append(this.submodal.body);
        this.open();
        return super.done(standardResponse);
    }
}
exports.Modal = Modal;
